export const EMAIL_CODES = {
  E003: 'E003',
  E004: 'E004',
  E005: 'E005',
  E006: 'E006',
  E007: 'E007',
  E008: 'E008',
  E009: 'E009',
  E010: 'E010',
  E011: 'E011',
  E012: 'E012',
  E013: 'E013',
  E014: 'E014',
  E017: 'E017',
  E030: 'E030',
  E031: 'E031',
  E032: 'E032',
  E039: 'E039',
  E040: 'E040',
  E041: 'E041',
  E047: 'E047',
  E048: 'E048',
  E049: 'E049',
  E050: 'E050'
}
